import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
// Base auth selectors that can be shared across auth-related selector files
export const getScopes = basicSelector(state => state.auth.user.scopes);
export const getGates = basicSelector(state => state.auth.gates);